module.exports = __webpack_public_path__ + "img/directional.939cdca2.png";